/**
 * Boost balance display component.
 * Shows current balance with optional purchase button.
 */

import { Zap } from "lucide-react";
import { usePayment } from "../lib/PaymentContext";

interface BoostBalanceProps {
  showPurchaseButton?: boolean;
  onPurchaseClick?: () => void;
  compact?: boolean;
}

export default function BoostBalance({
  showPurchaseButton = false,
  onPurchaseClick,
  compact = false,
}: BoostBalanceProps) {
  const { boostBalance, loading } = usePayment();

  // Show actual balance (or default) immediately - don't block on loading
  // This prevents long loading spinners when cloud functions are slow
  const displayBalance = boostBalance;

  if (compact) {
    return (
      <div className="flex items-center gap-1.5 text-sm">
        <Zap className="h-4 w-4 text-yellow-500" />
        <span className={`font-medium ${loading ? "opacity-50" : ""}`}>
          {displayBalance.toLocaleString()}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2">
        <Zap className="h-5 w-5 text-yellow-500" />
        <div>
          <span className={`font-semibold text-lg ${loading ? "opacity-50" : ""}`}>
            {displayBalance.toLocaleString()}
          </span>
          <span className="text-muted-foreground text-sm ml-1">boosts</span>
        </div>
      </div>
      {showPurchaseButton && (
        <button
          onClick={onPurchaseClick}
          className="text-sm text-blue-600 hover:text-blue-700 font-medium"
        >
          Buy more
        </button>
      )}
    </div>
  );
}
